<template>
  <div class="order-number-section" v-if="business && (business.amendmentOfBusinessNumber || haveProductionOption)">
    <SidebarAccordion :title="business.amendmentOfBusinessNumber ? 'Origine' : 'Dossier'" :default-open="false" v-bind="$attrs">
      <template #summary>
        <span v-if="folderNumber">n°{{ folderNumber }}</span>
      </template>

      <p v-if="business.amendmentOfBusinessNumber" class="amendment-note">Avenant du devis n°{{ business.amendmentOfBusinessNumber }}</p>

      <div v-else-if="haveProductionOption" class="folder-field-row">
        <CustomTextField :content="orderNumberInput" style="margin-right: 15px" />
        <CustomTooltip message="Allez vers le dossier" @click="goToProduction()" style="cursor: pointer" class="button-icon-custom">
          <span class="fas fa-file-export"></span>
        </CustomTooltip>
        <CustomTooltip v-if="!readOnly" message="Modifier le numéro de dossier" @click="openEditCommandNumberModal()" style="cursor: pointer" class="button-icon-custom">
          <span class="fas fa-file-pen"></span>
        </CustomTooltip>
      </div>
    </SidebarAccordion>
  </div>
  <EditCommandNumberModal ref="editCommandNumberModal" :callback=callback />
</template>

<script>
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import CustomTooltip from "@/components/CustomTooltip.vue";
import EditCommandNumberModal from "@/components/modals/EditCommandNumberModal.vue";
import SidebarAccordion from "@/components/businessEdition/SidebarAccordion.vue";
import router from "@/router";

export default {
  name: 'OrderNumberSection',
  components: {EditCommandNumberModal, CustomTextField, CustomTooltip, SidebarAccordion },
  // Les attributs non déclarés (open, toggle-callback...) sont transmis à l'accordéon pour pouvoir piloter son état depuis le parent
  inheritAttrs: false,
  props: {
    business: { type: Object, default: undefined },
    orderNumberInput: { type: Object, required: true },
    callback: {type: Function, default: undefined},
    readOnly: {type: Boolean, default: false},
  },
  computed: {
    folderNumber() {
      return this.business.amendmentOfBusinessNumber || this.business.orderNumber;
    },
    haveProductionOption() {
      return localStorage && localStorage.options && localStorage.options.includes('production');
    }
  },
  methods: {
    openEditCommandNumberModal(){
      this.$refs.editCommandNumberModal.openModal(this.business);
    },
    goToProduction(){
      router.push(`/dossiers?orderId=${this.business.orderNumber}#filter`);
    }
  }
};
</script>

<style lang="stylus" scoped>
.folder-field-row
  display flex
  gap 10px

.button-icon-custom
  margin-top 25px

.amendment-note
   margin 0
   font-size 12px
   font-weight 600
   line-height 1.4
   color #2b3340
</style>
